export const getMode = ({ active, href }) => {
    if (active) {
        return 'active';
    }
    if (href === undefined) {
        return 'disabled';
    }
    return 'visited';
};
